"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
ShopService.$inject = ['api', '$q', 'Popeye', '_download'];
function ShopService(api, $q, Popeye, _download) {
    var service = {};
    service.openStockModal = function (product) {
        var delay = $q.defer();
        var modal = Popeye.openModal({
            template: require('../views/modal-product-stock.html'),
            containerClass: 'modal-priority important',
            modalClass: 'stock-question-modal',
            controller: ['$scope', function ($scope) {
                    $scope.title = product.name;
                    $scope.message = null;
                    $scope.question = {
                        product_id: product._id,
                        product_name: product.name,
                        _ext_sifra: product._ext_sifra,
                        type: 0,
                        question: ''
                    };
                    $scope.clearMessage = function () {
                        $scope.message = null;
                    };
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        modal.close();
                    };
                    $scope.exit = function () {
                        modal.close();
                    };
                    $scope.send = function () {
                        var send = true;
                        if ($scope.question.type == 1 && $scope.question.question == '') {
                            send = false;
                            $scope.message = "Molimo Vas unesite vaš upit, predlog ili ponudu.";
                        }
                        if (send) {
                            api.post('/b2b/question/product', $scope.question).then(function (response) {
                                $scope.ok();
                            }, function (error) {
                                $scope.message = error.data;
                                $scope.errors = error.data;
                            });
                        }
                    };
                }]
        });
        return delay.promise;
    };
    service.exportListModal = function (products, sort) {
        var delay = $q.defer();
        var modal = Popeye.openModal({
            template: require('../views/modal-export-products.html'),
            containerClass: 'modal-priority',
            modalClass: 'products-export-modal',
            controller: ['$scope', '_download', function ($scope, _download) {
                    $scope.products = products;
                    $scope.sort = sort;
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        modal.close();
                    };
                    $scope.exit = function () {
                        modal.close();
                    };
                    $scope.loading = false;
                    $scope.export = function (type) {
                        $scope.loading = true;
                        var ids = [];
                        lodash_1.default.each($scope.products, function (child, index) {
                            ids.push({ _id: child._id });
                        });
                        var data = {
                            sort: $scope.sort,
                            show_vat: $scope.show_vat,
                            currency_value: $scope.currency_value,
                            show_prices: $scope.show_prices
                        };
                        _download.directDownload('products-list', type, { products: ids, data: data }).then(function (response) {
                            $scope.loading = false;
                            modal.close();
                        }, function (error) {
                            console.log('error');
                        });
                    };
                }]
        });
        return delay.promise;
    };
    service.getSortTypes = function () {
        return [
            { name: 'Cena opadajuće', sort: 'price', type: "desc", icon: 'filter_list', active: 0 },
            { name: 'Cena rastuće', sort: 'price', type: "asc", icon: 'filter_list', active: 1 },
            { name: 'Naziv opadajuće', sort: 'name', type: "desc", icon: 'filter_list', active: 0 },
            { name: 'Naziv rastuće', sort: 'name', type: "asc", icon: 'filter_list', active: 0 }
        ];
    };
    return service;
}
exports.ShopService = ShopService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/services/shop.js
// module id = 356
// module chunks = 0